import React from "react";

type ListingModalStickyWrapperProps = React.ComponentProps<"div">;

export const ListingModalStickyWrapper = ({
  children,
  ...props
}: ListingModalStickyWrapperProps) => {
  return (
    <div className="hidden lg:inline-block md:w-[35%] xl:w-[30%] pb-[26px]">
      <div className="sticky top-[100px]" {...props}>
        {children}
      </div>
    </div>
  );
};
